import type { FileUploadResponse } from '../service/file-upload-response';
import {
  isSuccessFileUploadResponse,
  isErrorFileUploadResponse,
} from '../service/file-upload-response';

export function getFileUploadResponseId(
  response: FileUploadResponse<string>,
  index: number,
): string {
  if (isSuccessFileUploadResponse(response)) {
    return `${response.id}`;
  }

  if (isErrorFileUploadResponse(response)) {
    return `error${index}`;
  }

  return `${response.file.name}${response.file.size}${response.file.lastModified}`;
}
